<form [formGroup]="generalForm">
  <input type="text" type="hidden" formControlName="notes_visibility" id="notes_visibility" name="notes_visibility"/>
  <!-- Fila 1: Referencia + Sales + Agente (col-4 + col-4 + col-4) -->
  <div *ngIf="account_type == 'broker'">
    <div class="row">
      <div class="col-12 col-xl-4 mb-3">
        <label for="broker_reference" class="form-label">{{
          "inputs.reference" | translate
        }}</label>
        <div class="input-group div-copy">
          <input type="text" class="form-control" id="broker_reference" #inputBrokerReference
            formControlName="broker_reference" placeholder="{{
              'inputs.reference' | translate
            }}" required />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary copy" type="button"
              (click)="copyToClipboard(inputBrokerReference.value,$event)">
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-4 mb-3">
        <label for="broker_sales_agent_id" class="form-label">{{
          "inputs.broker_sales_agent" | translate
        }}</label>
        <ng-select formControlName="broker_sales_agent_id" [items]="salesAgentData" bindValue="reference"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="true"
          [searchFn]="searchAgent" [notFoundText]="'tables.no_results' | translate">
          <ng-template ng-label-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
        </ng-select>
      </div>
      <div class="col-12 col-xl-4 mb-3">
        <label for="broker_agent_id" class="form-label">{{
          "inputs.broker_agent" | translate
        }}</label>
        <ng-select formControlName="broker_agent_id" [items]="agentData" bindValue="reference"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          [searchFn]="searchAgent" [notFoundText]="'tables.no_results' | translate">
          <ng-template ng-label-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
        </ng-select>
      </div>
    </div>
  </div>
  <div *ngIf="account_type == 'supplier'">
    <div class="row">
      <div class="col-6 mb-3">
        <label for="supplier_reference" class="form-label">{{
          "inputs.supplier_reference" | translate
        }}</label>
        <div class="input-group div-copy">
          <input type="text" class="form-control" id="supplier_reference" formControlName="supplier_reference"
            placeholder="{{
              'inputs.supplier_reference' | translate
            }}" required #supplierInput/>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary copy" #inputSupplierReference type="button"
              (click)="copyToClipboard(supplierInput.value,$event)">
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-6 mb-3">
        <label for="supplier_agent_id" class="form-label">{{
          "inputs.supplier_agent" | translate
        }}</label>
        <ng-select formControlName="supplier_agent_id" [items]="agentData" bindValue="reference"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          [searchFn]="searchAgent" [notFoundText]="'tables.no_results' | translate">
          <ng-template ng-label-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
        </ng-select>
      </div>
    </div>
  </div>

  <!-- Fila 2: Financiera — mobile: col-12 + col-6+col-6, desktop: 3x col-4 -->
  <div class="row">
    <div [ngClass]="draft ? 'col-12 col-xl-4 mb-3' : 'col-12 mb-3'">
      <label for="vendor" class="form-label">{{ "inputs.vendor" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <ng-select formControlName="vendor_id" [items]="vendorData" bindValue="reference" bindLabel="name"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
      </ng-select>
    </div>
    <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
      <label for="vendor" class="form-label">{{ "inputs.vendor_quote_reference" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <div class="input-group div-copy">
        <input type="text" class="form-control" id="vendor_quote_reference" #inputVendorOfertReference
          formControlName="vendor_quote_reference"
          placeholder="{{ 'inputs.vendor_quote_reference' | translate }}" required />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary copy" type="button"
            (click)="copyToClipboard(inputVendorOfertReference.value,$event)">
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
      <label for="vendor" class="form-label">{{ "inputs.vendor_reference" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <div class="input-group div-copy">
        <input type="text" class="form-control" id="vendor_reference" #inputVendorReference
          formControlName="vendor_reference" placeholder="{{ 'inputs.reference' | translate }}" required />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary copy" type="button"
            (click)="copyToClipboard(inputVendorReference.value,$event)">
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Fila 3: Supplier/Broker — mobile: col-12 + col-6+col-6, desktop: 3x col-4 -->
  <div *ngIf="account_type === 'broker'" class="row">
    <div [ngClass]="draft ? 'col-12 col-xl-4 mb-3' : 'col-12 mb-3'">
      <label for="supplier" class="form-label">{{ "inputs.supplier" | translate }}
        <!--   <span class="required">*</span> --></label>
      <ng-select formControlName="supplier_id" [items]="supplierData" bindValue="reference" bindLabel="name"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate" (change)="changeSupplier($event)">
      </ng-select>
    </div>
    <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
      <label for="supplier" class="form-label">{{ "inputs.supplier_reference" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <div class="input-group div-copy">
        <input type="text" class="form-control" id="supplier_reference" #inputSupplierReference2
          formControlName="supplier_reference" placeholder="{{ 'inputs.reference' | translate }}" required />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary copy" type="button"
            (click)="copyToClipboard(inputSupplierReference2.value,$event)">
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
      <label for="supplier" class="form-label">{{ "inputs.supplier_agent" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <input type="text" type="hidden" formControlName="supplier_agent_id" />
      <div class="input-group">
        <input type="text" class="form-control" id="supplier_agent" formControlName="supplier_agent"
          placeholder="{{ 'inputs.agent' | translate }}" required />
      </div>
    </div>
  </div>
  <div *ngIf="account_type === 'supplier'">
    <div class="row">
      <div class="col-12 col-xl-4 mb-3">
        <label for="broker" class="form-label">{{ "inputs.broker" | translate }}</label>
        <ng-select formControlName="broker_id" [items]="brokerData" bindValue="reference" bindLabel="name"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          [notFoundText]="'tables.no_results' | translate">
        </ng-select>
      </div>
      <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
        <label for="broker" class="form-label">{{ "inputs.broker_reference" | translate }}</label>
        <div class="input-group div-copy">
          <input type="text" class="form-control" id="broker_reference" #inputBrokerReference2
            formControlName="broker_reference" placeholder="{{ 'inputs.reference' | translate }}" required />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary copy" type="button"
              (click)="copyToClipboard(inputBrokerReference2.value,$event)">
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
        <label for="broker" class="form-label">{{ "inputs.broker_agent" | translate }}</label>
        <input type="text" type="hidden" formControlName="broker_agent_id" />
        <div class="input-group">
          <input type="text" class="form-control" id="broker_agent" formControlName="broker_agent"
            placeholder="{{ 'inputs.agent' | translate }}" />
        </div>
      </div>
    </div>
  </div>

  <!-- Fila 4: Código + tipo + fecha — mobile: col-6+col-6 / col-12, desktop: 3x col-4 -->
  <div class="row">
    <div class="col-6 col-xl-4 mb-3" *ngIf="draft">
      <label for="supplier_seller_code" class="form-label">{{ "inputs.supplier_seller_code" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <ng-select formControlName="supplier_seller_code" [items]="supplierSellerCodes" bindValue="key" bindLabel="name"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
      </ng-select>
    </div>
    <div class="col-6 col-xl-4 mb-3" *ngIf="account_type != 'broker' && draft">
      <label for="supplier_type" class="form-label">{{ "inputs.supplier_type" | translate }}
        <!--   <span class="required">*</span> -->
      </label>
      <ng-select formControlName="supplier_type" [items]="supplierTypeData" bindValue="key" bindLabel="name"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
      </ng-select>
    </div>
    <div class="col-12 col-xl-4 mb-3" *ngIf="account_type != 'broker' && draft">
      <label for="vendor_date" class="form-label">{{ "inputs.vendor_date" | translate }}</label>
      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{ 'inputs.i.vendor_date' | translate }}</span>
      </span>
      <div class="input-group">
        <mat-form-field appearance="fill">
          <input matInput [matDatepicker]="vendor_date"
            formControlName="vendor_date" placeholder="{{ 'inputs.vendor_date' | translate }}" />
          <mat-datepicker-toggle matSuffix [for]="vendor_date"></mat-datepicker-toggle>
          <mat-datepicker #vendor_date></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div *ngIf="draft">
    <!-- Fila 5: Etapa + botones — mobile: col-12 / col-12, desktop: col-6 + col-6 -->
    <div class="row">
      <div class="col-12 col-xl-6 mb-3">
        <label for="stage" class="form-label">{{ "inputs.stage" | translate }}
          <span class="required">*</span></label>
        <ng-select formControlName="stage" [items]="stagesData" bindValue="key"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          [notFoundText]="'tables.no_results' | translate" (change)="changeStage($event)"
          [disabled]="isDigitalCircuit">
          <ng-template ng-label-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
        </ng-select>
        <small *ngIf="isDigitalCircuit" class="text-muted">
          {{ "swal_messages.orders.order_digital_stage_locked" | translate }}
        </small>
      </div>
      <div class="col-12 col-xl-6 mb-3 d-flex align-items-end">
        <div class="btn-next" *ngIf="btn_fast_actions && !isDigitalCircuit">
          <button *ngIf="next_ok" type="submit" class="btn btn-primary btn-next_ok"
            (click)="onSubmitOrderFast(next_ok)"> <i class="icon-next-circle"></i>
            {{ "badge-status_select-stage."+ next_ok | translate }}
          </button>
          <button *ngIf="next_ko" type="submit" class="btn btn-primary btn-next_ko"
            (click)="onSubmitOrderFast(next_ko)"> <i class="icon-pause-circle"></i>
            {{ "badge-status_select-stage."+ next_ko | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="row private-background" *ngIf="notesMode === 'private'">
      <div class="col-12 mb-3">
        <label for="notes" class="form-label">{{ "inputs.addinternote" | translate }}</label>
        <div class="input-group">
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="notesMode === 'public'">
      <div class="col-12 mb-3">
        <label for="notes" class="form-label">{{ "inputs.addnote" | translate }}</label>
        <div class="input-group">
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
    </div>
  </div>
</form>
